'use client';
import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import LucideIcon from '@/components/ui/LucideIcon';

interface RatingBadgeProps {
  rating?: number;
  reviewCount?: number;
}

export const ReviewInformation = ({ rating, reviewCount }: RatingBadgeProps) => {
  if (!rating || !reviewCount) {
    return (
      <Flex align="center" gap={1.5}>
        <LucideIcon name="Star" boxSize={3.5} color="orange.60" fill="orange.60" />
        <Text color="neutral.60" textStyle="body3" fontWeight="regular">
          No reviews yet
        </Text>
      </Flex>
    );
  }

  return (
    <Flex align="center" gap={1.5}>
      <Text color="neutral.60" textStyle="body3" fontWeight="regular">
        {rating.toFixed(1)}
      </Text>
      <Flex gap={1}>
        {Array(5)
          .fill('')
          .map((_, i) => (
            <LucideIcon
              name="Star"
              boxSize={3.5}
              color={i < Math.floor(rating) ? 'orange.50' : 'neutral.20'}
              fill={i < Math.floor(rating) ? 'orange.50' : 'transparent'}
              key={i}
            />
          ))}
      </Flex>
      <Text color="neutral.60" textStyle="body3" fontWeight="regular">
        ({reviewCount})
      </Text>
    </Flex>
  );
};
